<template>
  <v-container>
    <v-row align="center">
      <v-col
        class="d-flex"
        cols="6"
        sm="3"
      >
        <v-select
          :items="requestCountries"
          :item-text="item => $t(item.text)"
          :label="$t('country')"
          v-model="country"
          :rules="[v => !!v || $t('country_required')]"
          :menu-props="{ maxHeight: 450 }"
          @change="updateAgencies(country)"
        ></v-select>
      </v-col>

      <v-col
        class="d-flex"
        cols="6"
        sm="3"
      >
        <v-select
          :items="requestAgencies"
          v-model="agency"
          :label="$t('agency')"
          clearable
        ></v-select>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="3"
      >
        <v-text-field
          :label="$t('unit')"
          v-model="unit"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row align="center">
      <v-col
        cols="12"
        sm="6"
        md="6"
      >
        <v-text-field
          :label="$t('operation_name')"
          v-model="operation"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row align="center">
      <v-col
        cols=12
        sm=6
        md=3
      >
        <v-text-field
          :label="$t('judicial_number')"
          v-model="judicialNumber"
        ></v-text-field>
      </v-col>

      <v-col
        cols=12
        sm=6
        md=3
      >
        <v-text-field
          :label="$t('judicial_authority')"
          v-model="judicialAuthority"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-checkbox
      v-model="sharing"
      :label="$t('information_shared_question')"
    ></v-checkbox>

    <v-textarea
      v-if="sharing"
      visible
      outlined
      :label="$t('indicate_agency')"
      v-model="sharing_details"
      :rules="[v => !!v || $t('sharing_details_required')]"
    ></v-textarea>
  </v-container>
</template>

<script>
import { maocData } from '../../services/MaocData'

export default {
  name: 'RequestEntity',
  data: vm => ({
    requestCountries: maocData.asSortedLocalizedSelect('countries', 'countries'),
    controlType: maocData.controlType,
    requestAgencies: [],
    sharing: false,
    sharing_details: '',
    agency: '',
    unit: '',
    operation: '',
    country: '',
    judicialNumber: '',
    judicialAuthority: ''
  }),
  watch: {
  '$i18n.locale': function(newVal, oldVal) {
      this.requestCountries = maocData.asSortedLocalizedSelect('countries', 'countries')
    }
  },
  methods: {
    updateAgencies: function (country) {
      this.requestAgencies = maocData.agencies[country]
    },
    getData: function () {
      return {
        sharing: this.sharing,
        sharing_details: this.sharing_details,
        agency: this.agency,
        unit: this.unit,
        operation: this.operation,
        country: this.country,
        country_en: this.$t('countries.' + this.country, 'en'),
        judicialNumber: this.judicialNumber,
        judicialAuthority: this.judicialAuthority
      }
    },
    setData: function (data) {
      this.sharing = data.sharing
      this.sharing_details = data.sharing_details
      this.unit = data.unit
      this.operation = data.operation
      this.country = data.country
      this.updateAgencies(this.country)
      this.agency = data.agency
      this.judicialNumber = data.judicialNumber
      this.judicialAuthority = data.judicialAuthority
    }
  }
}
</script>
